<template>
  <el-container style="height: calc(100vh - 0px); border: 1px solid #eee;">
    <el-header style="display: flex; justify-content: space-between; height: 49px; align-items: center;">
      <div class="ft16" style="margin-left: 19px; margin-top: 6px;display: flex;">
       <img src="../../assets/logo.png" alt="" style="width: 100px;">
      </div>
      <div class="dl_at"  style="height: 20px;">
        <el-dropdown  @command="outLoginEvt" class="asds"  style="height: 30px;line-height: 30px;">
            <span class="el-dropdown-link">
             <!-- <img style="width: 33px; height: 35px" :src="avatar" alt="" /> -->
              <span class="mr5 ft12">{{ username }}</span>
              <img style="width: 13px; height: 13px; margin-left: 5px" alt=""    class="el-dropdown-link"/>
            </span>
            <el-dropdown-menu slot="dropdown"  style="top: 20px;">
              <el-dropdown-item command="1" >退出登陆</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
      </div>
    </el-header>
    <el-container>
      <el-container >
        <el-aside   width="171px" style="border-right: 1px solid #d9d9d9;">
          <el-menu   :default-active="activeIndex"  class="el-menu-vertical-demo"  >
            <el-menu-item index="1" @click="handleMenuClick('1') ">
              <span slot="title">原始素材</span>
            </el-menu-item>
            <el-menu-item index="2" @click="handleMenuClick('2')">
              <span slot="title">上架中</span>
            </el-menu-item>
            <el-menu-item index="3" @click="handleMenuClick('3')"   >
              <span slot="title">已下架</span>
            </el-menu-item>
             <el-menu-item index="4" @click="handleMenuClick('4')"   >
                <span slot="title">回收站</span>
              </el-menu-item>
          </el-menu>
        </el-aside>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'GlobalDrawer',
  props: {
    title: {
      type: String,
      default: ''
    },
    avatar: {
      type: String,
      default: '../../images/1.jpg'
    },
    activeIndex: {
      type: String,
      default: '1'
    }
  },
  data() {
    return {
      localActiveIndex: this.activeIndex ,// 通过 prop 初始化一个组件内部的数据
      username:null,
       selectedColor: 'white',
      isDaytime: true,
      userRole:null,
    };
  },
  created(){
  },
  mounted(){
  },

  methods: {

   outLoginEvt(e) {
      if (e == 1) {
        localStorage.removeItem("vm_token");
        window.location.href = '/';
      }
    },

     handleMenuClick(index) {
      this.localActiveIndex = index; // 更新当前选中的菜单项的值
      console.log(123);
      // 根据菜单项的值进行路由跳转
      switch (index) {
        case '1':
          this.$router.push('/Grounding');
          break;
        case '2':
          this.$router.push('/original');
          break;
        case '3':
            this.$router.push('/retrieve');
          break;
        case '4':
          this.$router.push('/undercarriage');
          break;
      }
    },
    //退出登录清除token
  //   outLoginEvt(e) {
  //     if (e == 1) {
  //       localStorage.removeItem("token");
  //       window.location.href = 'https://www.vimiu3d.com/';
  //   }
  // }
}
}
</script>

<style scoped lang="less">
/* 添加你的样式 */
.el-header {
  background-color: #fff;
  color: #333;
  line-height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0px;
  color: #333;
  line-height: 60px;
  z-index: 100;
  border-bottom: 1px solid #d1d1d1;
  /* 使Header在其他内容之上 */
}
/* 固定左侧的项目管理列表 */
.el-aside {
  position: fixed;
  top: 50px;
  /* 顶部Header的高度，根据你的实际Header高度调整 */
  left: 0;
  width: 155px;
  height: 100%;
  /* 使其充满整个可视区域的高度 */
  z-index: 99;
  /* 使其在正文内容之上 */
}

/deep/.el-menu-item.is-active{
  background:#ecf5ff;
}


/deep/.el-menu-item:nth-child(1) {
  height: 45px;
  line-height: 45px;
  color: #292929;
  font-size: 12px;
  padding-left: 20px;
  text-align: center;
}

/deep/.el-menu-item:nth-child(2) {
  height: 44px;
  line-height: 45px;
  color: #292929;
  font-size: 12px;
  padding-left: 20px;
  text-align: center;
}


/deep/.el-menu-item {
  height: 44px;
  line-height: 45px;
  color: #292929;
  font-size: 12px;
  padding-left: 20px;
  text-align: center;
}
/deep/.el-menu-item-group__title{
  height: 44px;
  line-height: 45px;
  color: #292929;
  font-size: 12px;
  text-align: center;
}
/deep/.el-popper{
  top: 10px !important;
}

#colorChanger span{
  cursor: pointer;
}
/deep/.el-menu-item-group__title{
  padding: 0px 0 7px 0px !important;
}
/deep/.el-submenu .el-menu-item{
  min-width: 170px;
}
</style>



// WEBPACK FOOTER //
// src/backHome/components/menu.vue